import React from "react";

function Loader({ isOpen }) {
  if (!isOpen) return null;

  return (
    <>
      <div className="spinner-wrapper">
        <div className="blue-spinner"></div>
      </div>
    </>
  );
}

export default Loader;
